import { CircularProgress, Grid, Typography } from '@mui/material';
import { Option, Product, ProductType, ShoppingCartItem } from '@thro-types/leihbar';

import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useOptionsForProductQuery } from 'api/hooks/leihbar';
import { translations } from 'locales/i18n';

import { OptionDetail } from '../../ProductDetailPage/components';

interface Props {
  product: Product;
}
export const OptionsStep = ({ product }: Props) => {
  const { t } = useTranslation();
  const { values, setFieldValue, validateForm } = useFormikContext<
    ShoppingCartItem & { options: Option[] }
  >();

  const getQueryVariables = () => {
    if (product.productType === ProductType.BUNDLE && !!product.products?.length) {
      return { ids: product.products?.map(p => p.id) };
    } else {
      return { id: product.id };
    }
  };
  const { data: options, isLoading } = useOptionsForProductQuery(product.id, {
    params: getQueryVariables()
  });

  const handleToggle = (option: Option) => {
    let updatedOptions = [...values.options];
    if (values.options.includes(option)) {
      updatedOptions = updatedOptions.filter(item => item !== option);
    } else {
      updatedOptions.push(option);
    }
    setFieldValue(`options`, updatedOptions);
  };

  useEffect(() => {
    validateForm(values);
  }, [validateForm, values]);

  return (
    <Grid container sx={{ justifyContent: 'center' }}>
      {!isLoading && !!options?.length ? (
        options.map((option, index) => (
          <Grid container item xs={12} md={6} lg={6} xl={6} key={option.id}>
            <OptionDetail
              option={option}
              inModalView
              isSelected={!!values.options.filter(op => op.id === option.id).length}
              handleToggle={() => handleToggle(option)}
            />
          </Grid>
        ))
      ) : isLoading ? (
        <CircularProgress />
      ) : (
        <Typography variant="h6">
          {t(translations.pages.leihbar.shoppingCart.noOptions())}
        </Typography>
      )}
    </Grid>
  );
};
